<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Rides</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Rides
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="users-view">
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <h3 class="mb-1"><i class="feather icon-info"></i> Ride Details</h3>
                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>Ride Id:</td>
                                            <td>{{ trip.id }}</td>
                                        </tr>
                                        <tr>
                                            <td>Pickup Address:</td>
                                            <td>{{ trip.pickup_address }}</td>
                                        </tr>
                                        <tr>
                                            <td>Drop Address:</td>
                                            <td>{{ trip.drop_address }}</td>
                                        </tr>
                                        <tr>
                                            <td>Ride Request Initiated at:</td>
                                            <td>{{ formatDateTime(trip.trip_request.created_at) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Ride Request Accepted at:</td>
                                            <td>{{ formatDateTime(trip.trip_request.driver_accepted_at) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Ride Started at:</td>
                                            <td>{{ formatDateTime(trip.start_time) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Ride Ended at:</td>
                                            <td>{{ formatDateTime(trip.end_time) }}</td>
                                        </tr>

                                        <tr>
                                            <td>Status:</td>
                                            <td>
                                                <span :class="'users-view-status badge badge-' + statusClass(trip.status)">
                                                    {{ trip.status }}
                                                </span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12 col-md-6">
                                    <h3 class="mb-1"><i class="feather icon-info"></i>Insurance Details</h3>
                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>Insurance Policy Id:</td>
                                            <td>{{ trip.insurance_policy_id ?? "NIL"}}</td>
                                        </tr>
                                        <tr>
                                            <td>Insurance Policy No:</td>
                                            <td>{{ trip.insurance_policy_no ?? "NIL"}}</td>
                                        </tr>
                                        <!--                                        <tr>-->
                                        <!--                                            <td>Insurance Name:</td>-->
                                        <!--                                            <td>{{ trip.insurance?.insurance?.name ?? "NIL"}}</td>-->
                                        <!--                                        </tr>-->
                                        <!--                                        <tr>-->
                                        <!--                                            <td>Item Value:</td>-->
                                        <!--                                            <td>{{ trip.insurance?.item_value ?? "NIL"}}</td>-->
                                        <!--                                        </tr>-->
                                        <!--                                        <tr>-->
                                        <!--                                            <td>Insurance Amount:</td>-->
                                        <!--                                            <td>{{ trip?.insurance?.insurance_amount ?? "NIL" }}</td>-->
                                        <!--                                        </tr>-->
                                        </tbody>
                                    </table>

                                    <h3 class="mt-3 mb-1"><i class="feather icon-info"></i>Vehicle Details</h3>
                                    <table class="table table-borderless">
                                        <tbody>
<!--                                            <tr>-->
<!--                                                <td>Vehicle Id:</td>-->
<!--                                                <td>{{ trip.vehicleData.id ?? "NIL"}}</td>-->
<!--                                            </tr>-->
                                            <tr>
                                                <td>Vehicle Name:</td>
                                                <td>{{ trip.vehicleData.name ?? "NIL"}}</td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle Make:</td>
                                                <td>{{ trip.vehicleData.make ?? "NIL"}}</td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle Model:</td>
                                                <td>{{ trip.vehicleData.model ?? "NIL"}}</td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle License Plate:</td>
                                                <td>{{ trip.vehicleData.license_plate ?? "NIL"}}</td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle Owner:</td>
                                                <td>{{ trip.vehicleData.owner ?? "NIL"}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12 col-md-6 mt-3">
                                    <h3 class="mb-1"><i class="feather icon-info"></i> User Details</h3>

                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>User Name:</td>
                                            <td>{{ trip.passenger?.first_name + " " + trip.passenger?.last_name }}</td>
                                        </tr>
                                        <tr>
                                            <td>User Email:</td>
                                            <td>{{ trip.passenger?.email }}</td>
                                        </tr>
                                        <tr>
                                            <td>User Phone:</td>
                                            <td>{{ trip.passenger?.phone }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12 col-md-6 mt-3">
                                    <h3 class="mb-1"><i class="feather icon-info"></i> Driver Details</h3>
                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>Driver Name:</td>
                                            <td>{{ trip.driver?.first_name + " " + trip.driver?.last_name }}</td>
                                        </tr>
                                        <tr>
                                            <td>Driver Email:</td>
                                            <td>{{ trip.driver?.email }}</td>
                                        </tr>
                                        <tr>
                                            <td>Driver Phone:</td>
                                            <td>{{ trip.driver?.phone_number }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'Trip'},
    name: 'TripShow',
    props: ['trip'],
    layout: Layout,
    data: () => ({
        saving: false
    }),
    methods: {
        formatDateTime(value) {
            if (!value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        statusClass(value) {
            if (value === 'pending') {
                return "warning";
            } else if (value === 'accepted' || value === 'in_progress' || value === 'picked_up' || value === 'in_transit')
            {
                return "success";
            } else if (value === 'completed')
            {
                return "primary";
            } else {
                return "danger";
            }
        },
    },
    mounted() {

    },
}
</script>
